import React from "react";

type RechnungColorProps = React.SVGProps<SVGSVGElement>;

// "Rechnung" (invoice) has no brand logo — on the reference asset it is simply the
// word in a bordered box. Rendered as a wordmark badge for parity with the card logos.
const RechnungColor: React.FC<RechnungColorProps> = (props) => (
  <svg viewBox="0 0 96 32" role="img" fill="none" {...props}>
    <title>Rechnung</title>
    <rect
      x="1"
      y="1"
      width="94"
      height="30"
      rx="4"
      fill="#FFFFFF"
      stroke="#1A1918"
      strokeWidth="2"
    />
    <text
      x="48"
      y="21"
      textAnchor="middle"
      fontFamily="heebo, roboto, arial, helvetica, sans-serif"
      fontSize="15"
      fill="#1A1918"
    >
      Rechnung
    </text>
  </svg>
);

export default RechnungColor;
